import { Component, OnInit, ViewChild } from '@angular/core';
import { TicketService } from 'src/app/services/ticket/ticket.service';
import { GeneralService } from 'src/app/services/general.service';
import { ActivatedRoute, Router } from '@angular/router';
import $ from "jquery";
import { FormControl, FormGroup } from '@angular/forms';
import { takeUntil } from "rxjs/operators";
import 'quill-mention'
import { QuillEditorComponent } from 'ngx-quill'
import { OrganizationService } from 'src/app/services/organizationservice';
import { TicketChatService } from 'src/app/services/ticket/ticket-chat.service';
import { Subject } from "rxjs";
import { TicketModel } from 'src/app/models/ticket/ticket.model';
import { ChatService } from 'src/app/services/chat.service';
import { TkAllNotesComponent } from '../ticket-view/textareas/tk-all-notes/tk-all-notes.component';
import * as th from 'src/assets/calendar-assets/core/locales/th';

@Component({
  selector: 'app-internal-response-view',
  templateUrl: './internal-response-view.component.html',
  styleUrls: ['./internal-response-view.component.css']
})
export class InternalResponseViewTicketComponent implements OnInit {
  ticketCode: string;
  selectedFile: File;
  chatList: any[] = [];
  activeTab = "reply";
  disableBtn = false;
  shareForm = new FormGroup({
    shareTo: new FormControl("general"),
  });

  selectedTicket: TicketModel;

  private unscribe = new Subject();
  content = ''
  matContent = ''
  modules: any;
  agentsArr: any[] = [];
  agentsObj: any = {};
  noteLoading = false;
  agentsTobeNotifiedList = []
  quillEditorOpt = {
    styles: {
      'min-height': '70px',
      'background': '#F2F2F2',
      'border': 'none',
      'font-family': '"Poppins", sans-serif'
    },
    placeholder: 'Please provide feedback to this ticket'
  }
  internalGroupUsers: any = [];
  isReady: boolean = false;
  @ViewChild(QuillEditorComponent) editor: QuillEditorComponent
  orgID: string = '';
  userID: string= '';
  name: string ='';
  orgName: string ='';
  @ViewChild('tkAllNotes') tkAllNotes: TkAllNotesComponent

  constructor(
    private router: Router,
    private ticketSrv: TicketService,
    private gs: GeneralService,
    private route: ActivatedRoute,
    private orgSrv: OrganizationService,
    private ticketChatSrv: TicketChatService,
    private chatSrv: ChatService,
  ) { 
    this.route.params.subscribe((params) => {
      this.ticketCode = params.ticketCode;
      this.orgID = params.orgID;
      this.userID = params.userID;
      this.name = params.name;
      this.orgName = params.orgName;
      this.getChats({code: this.ticketCode});
    })
  }

  ngOnInit() {
    this.fetchActiveUsers();
  }

  getChats({ code }) {
    this.chatList = null;
    this.ticketChatSrv
      .fetchChatForInternalResponse(code)
      .pipe(takeUntil(this.unscribe))
      .subscribe((res: any) => {
        this.chatList = res.chatList;
        this.selectedTicket = res.ticket;
        if(this.selectedTicket == null || !this.selectedTicket.id){
          this.login();
        }
      },err => {
        console.log('ticket Error', err);
        this.login();
      }
      );
  }

  ngOnDestroy(){

  }

  onChangeTab(tabName: string) {
    this.activeTab = tabName;
  }

  onBrowseFile() {
    $("#fileUpload").click();
  }
  browseFile(event) {
    this.selectedFile = event.target.files[0];
  }
  upload() {
    
  }


  fetchActiveUsers() {
    this.orgSrv.getUsersInOrganizationInternalResponse(2, this.orgID).subscribe((res: any[]) => {
      this.mapAgents(res)
    })
  }
  getAgents(){
    this.ticketSrv.fetchTicketAgentForInternalResponse(this.orgID).subscribe((res: any[]) => {
      this.mapAgents(res)
    })
  }
  mapAgents(agents: any[]) {
    let isInternalPerson = false;
    const eligibleAgents = agents.filter(a => a.relationship && (a.relationship.agent || a.relationship.internalGroup));
    for (const agent of eligibleAgents) {
      if(agent.relationship && agent.relationship.internalGroup && agent.id == this.userID){
        isInternalPerson = true;
      }
      if(agent.id !== this.gs.user.id) {
        const {id, firstName, lastName } = agent;
        this.agentsArr.push({id, value: `${firstName} ${lastName}`})
        this.agentsObj[agent.id] = agent;
      }
    }
    if(!isInternalPerson){
      this.login();
      return;
    }
    this.getQuillModule()
  }
  login(){
    this.router.navigate(['/login']);
  }
  getQuillModule() {
    const modules = {
      mention: {
        allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
        onSelect: (item, insertItem) => {
          const editor = this.editor.quillEditor
          insertItem(item)
          // necessary because quill-mention triggers changes as 'api' instead of 'user'
          editor.insertText(editor.getLength() - 1, '', 'user')
        },
        source: (searchTerm, renderList) => {
          const values = this.agentsArr;
          if (searchTerm.length === 0) {
            renderList(values, searchTerm)
          } else {
            const matches = []

            values.forEach((entry) => {
              if (entry.value.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1) {
                matches.push(entry)
              }
            })
            renderList(matches, searchTerm)
          }
        }
      },
      toolbar: false
      }
      this.modules = modules;
      this.isReady = true;      
  }

  getAgentsToNotify() {
    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(this.content, 'text/html');
    const allMentions = htmlDoc.querySelectorAll('.mention');
    const mentionsId = [];
    allMentions.forEach(el => {
      mentionsId.push(el.attributes['data-id'].value)
    })
    const agentUniqueIds = Array.from(new Set(mentionsId))
    if(!agentUniqueIds.length) return;
    agentUniqueIds.forEach(id => {
      const agentDetail = this.agentsObj[id];
      this.agentsTobeNotifiedList.push({
        uniqueId: `${agentDetail.id}-${this.orgID}`,
        email: agentDetail.email,
        name: `${agentDetail.firstName} ${agentDetail.lastName}`,
        userId: agentDetail.id
      });
      if(agentDetail.relationship && agentDetail.relationship.internalGroup){
        this.internalGroupUsers.push(agentDetail);
      }      
    })
    this.notifyAgent();
  }

  notifyAgent() {
    if (this.agentsTobeNotifiedList.length) {
      const payload = {
        agentList: this.agentsTobeNotifiedList,
        ticketCode: this.selectedTicket.code,
        message: this.content,
        internalGroupUsers: this.internalGroupUsers
      }
      
      const userIds = this.agentsTobeNotifiedList.map(agent => agent.userId)
      const email_list = this.agentsTobeNotifiedList.map(agent => agent.email);      
      const savePayload = { ticketCode: this.selectedTicket.code, userIds, email_list }
      console.log('*** agentsTobeNotifiedList', this.agentsTobeNotifiedList);
      console.log('*** internal', this.internalGroupUsers);
      
      const user = {
                      id: this.userID, 
                      firstName:' ', 
                      lastName:this.name,
                      orgName: this.orgName
                    }
                    console.log('**** cur user', user);
                    
      this.chatSrv.notifyAgents(payload, this.internalGroupUsers, user).subscribe(() => {
        this.agentsTobeNotifiedList = []
        this.internalGroupUsers = [];
        this.chatSrv.saveAgentNotify(savePayload).subscribe((res) => {
        })
      })
    }
  }

  createNote() {
    if (this.content) {
      const payload = { 
        content: this.content, 
        ticketCode: this.selectedTicket.code, 
        type: 1, 
        internalGroupUsers:[],
        creatorID: this.userID,
        creatorName: `${this.name}`,        
       };
      this.noteLoading = true;
      this.getAgentsToNotify();
      if(this.internalGroupUsers && this.internalGroupUsers.length> 0){
        const internal = this.internalGroupUsers.map(user =>{
          return {fullname: user.fullName, id: user.id};
        });
        payload.internalGroupUsers = internal;
      }
      this.ticketSrv.createChatExtraForInternalResponse(payload).subscribe(() => {
        this.gs.sweetAlertSucess('Comment added successfully!')
        this.tkAllNotes.getNotes();
        this.content = ''
        this.noteLoading = false;
      }, () => {
        this.noteLoading = false;
        alert('Error occurred, try again!')
      })
    }
  }
}
